(function () {
  'use strict';
  if (!customElements.get('wuda-legacy-process')) {
    customElements.define('wuda-legacy-process', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        const signal = this._abort.signal;
        this._schedule = () => {
          if (!this._frame) this._frame = requestAnimationFrame(() => { this._frame = 0; this.update(); });
        };
        window.addEventListener('scroll', this._schedule, { passive: true, signal });
        window.addEventListener('resize', this._schedule, { passive: true, signal });
        window.addEventListener('load', this._schedule, { signal });
        this._motion.addEventListener('change', this._schedule, { signal });
        if (window.ResizeObserver) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(this);
        }
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this._schedule(); });
        this._schedule();
      }
      update() {
        const wrapper = this.querySelector('.process-wrapper');
        const line = this.querySelector('.process-line');
        const fill = this.querySelector('.process-line-fill');
        const items = Array.from(this.querySelectorAll('.process-item'));
        if (!wrapper || !line || !fill) return;
        line.hidden = items.length < 2;
        if (!items.length) return;
        const base = wrapper.getBoundingClientRect();
        const dots = items.map(item => item.querySelector('.process-dot').getBoundingClientRect());
        const centers = dots.map(dot => dot.top + dot.height / 2);
        const start = centers[0] - base.top;
        const length = Math.max(0, centers[centers.length - 1] - centers[0]);
        const trigger = window.innerHeight * 0.55;
        const reduced = this._motion.matches;
        // Measure first, write second. The fill is relative to the line, never offset twice.
        line.style.left = (dots[0].left - base.left + dots[0].width / 2) + 'px';
        line.style.top = start + 'px';
        line.style.bottom = 'auto';
        line.style.height = length + 'px';
        fill.style.top = '0px';
        fill.style.height = (reduced ? length : Math.min(length, Math.max(0, trigger - centers[0]))) + 'px';
        items.forEach((item, index) => item.classList.toggle('is-active', reduced || centers[index] <= trigger));
      }
      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        if (this._resize) this._resize.disconnect();
        cancelAnimationFrame(this._frame);
        this._frame = 0; this._abort = null;
      }
    });
  }
  if (!customElements.get('wuda-counter-section')) {
    customElements.define('wuda-counter-section', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        this._frames = new Set();
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._done = new WeakSet();
        this._items = Array.from(this.querySelectorAll('.content[data-count]'));
        const finish = () => {
          if (!this._motion.matches) return;
          if (this._observer) this._observer.disconnect();
          for (const id of this._frames) cancelAnimationFrame(id);
          this._frames.clear();
          this._items.forEach(item => {
            const el = item.querySelector('.counter');
            if (el) el.textContent = item.dataset.count;
          });
        };
        this._motion.addEventListener('change', finish, { signal: this._abort.signal });
        if (this._motion.matches || !window.IntersectionObserver) { finish(); return; }
        this._observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this._observer.unobserve(entry.target);
            this.animate(entry.target);
          });
        }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
        this._items.forEach(item => this._observer.observe(item));
      }
      animate(item) {
        if (this._done.has(item)) return;
        this._done.add(item);
        const el = item.querySelector('.counter');
        const raw = item.dataset.count.trim();
        // Keep formatted/ambiguous strings unchanged rather than displaying an incorrect number.
        if (!el || !/^-?\d+(?:\.\d+)?$/.test(raw)) return;
        const value = Number(raw);
        if (!Number.isFinite(value) || value === 0) return;
        const decimals = (raw.split('.')[1] || '').length;
        const start = performance.now();
        const tick = now => {
          if (!this.isConnected || this._motion.matches) { el.textContent = raw; return; }
          const progress = Math.min(1, (now - start) / 1200);
          el.textContent = progress === 1 ? raw : (value * (1 - Math.pow(1 - progress, 3))).toFixed(decimals);
          if (progress < 1) queue();
        };
        const queue = () => {
          const id = requestAnimationFrame(now => { this._frames.delete(id); tick(now); });
          this._frames.add(id);
        };
        queue();
      }
      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        if (this._observer) this._observer.disconnect();
        if (this._frames) for (const id of this._frames) cancelAnimationFrame(id);
        this._abort = null;
      }
    });
  }
})();
